const InterestBlocks = ({ data, selected, onToggle }) => {
  return (
    <div
      className="grid gap-2 mt-2"
      style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', display: 'grid' }}
    >
      {data.map((item) => {
        const isSelected = selected.some((i) => i.id === item.id);
        const isDisabled = item.jobCount === 0;
          return (
            <div
              key={item.id}
              onClick={() => {
                if (!isDisabled) {
                  onToggle('interests', item);
                }
              }}
              className={`cursor-pointer relative bg-gray-800 rounded-xl p-4 text-white flex items-start gap-4 shadow-md hover:shadow-lg transition
                ${isSelected ? 'border border-purple-500 bg-gray-700' : 'border border-transparent'}
                ${!isDisabled ? 'cursor-pointer hover:shadow-lg' : 'opacity-40 cursor-not-allowed hidden md:flex'}`}
            >
              <div className="text-2xl">{item.icon}</div>
              <div>
                <h3 className="font-semibold text-sm">{item.label}</h3>
                <p className="text-xs text-gray-400">{item.jobCount} métier{item.jobCount > 1 ? 's' : ''}</p>
              </div>
              <div className="absolute top-[-5px] right-[-5px] z-10">
                {isSelected && (
                  <div className="w-5 h-5 bg-purple-500 text-black rounded-full flex items-center justify-center text-xs font-bold">
                    ✓
                  </div>
                )}
              </div>
            </div>
          )
      })}
    </div>
  );
};
  
  export default InterestBlocks;
  